import React from 'react';
import globeIcon from '../assets/globe.png';
import batteryIcon from '../assets/battery.png';
import windIcon from '../assets/wind_energy.png';
import solarIcon from '../assets/solar_power.png';
import planningIcon from '../assets/planning.png';

const ExpertiseItem = ({ title, description, icon, doubleIcons }) => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '20px',
      marginBottom: '30px'
    }}>
      {/* Image container */}
      <div style={{
        minWidth: '80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: '5px'
      }}>
        {icon && (
          <img 
            src={icon} 
            alt={title}
            style={{
              height: '48px',
              width: '48px',
              objectFit: 'contain'
            }}
          />
        )}
        {doubleIcons && (
          <div style={{
            display: 'flex',
            gap: '8px'
          }}>
            {doubleIcons.map((icon, i) => (
              <img 
                key={i}
                src={icon} 
                alt={`icon-${i}`}
                style={{
                  height: '36px',
                  width: '36px',
                  objectFit: 'contain'
                }}
              />
            ))}
          </div>
        )}
      </div>

      {/* Border and text container */}
      <div style={{
        borderLeft: '3px solid #1a73e8',
        paddingLeft: '20px',
        flex: 1
      }}>
        <h3 style={{
          fontSize: '1.3rem',
          marginBottom: '10px',
          color: '#1a73e8',
          marginTop: 0
        }}>{title}</h3>
        <p style={{
          fontSize: '1rem',
          lineHeight: 1.6,
          color: '#555',
          marginTop: 0
        }}>{description}</p>
      </div>
    </div>
  );
};

const Expertise = () => {
  return (
    <section id="expertise" style={{
      padding: '80px 5%',
      backgroundColor: '#f9f9f9',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <h2 style={{
        fontSize: '2.5rem',
        textAlign: 'center',
        marginBottom: '50px',
        color: '#1a73e8'
      }}>Our Expertise</h2>
      
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '800px',
        width: '100%'
      }}>
        <ExpertiseItem 
          title="Pan-European Energy Modeling" 
          description="Comprehensive models covering power, gas, and hydrogen markets across Europe, with detailed cross-border analysis."
          icon={globeIcon}
        />
        <ExpertiseItem 
          title="PLEXOS Energy Software Specialists" 
          description="Expert implementation and customization of PLEXOS for complex energy scenarios and market simulations."
        />
        <ExpertiseItem 
          title="Battery Storage Optimization" 
          description="Advanced algorithms for optimal battery energy storage system (BESS) behavior and investment planning."
          icon={batteryIcon}
        />
        <ExpertiseItem 
          title="Renewable Integration Analysis" 
          description="Specialized modeling for integrating variable renewable energy sources into existing power systems."
          doubleIcons={[windIcon, solarIcon]}
        />
        <ExpertiseItem 
          title="Transmission & Infrastructure Planning" 
          description="Detailed analysis and optimization of transmission networks and energy infrastructure investments."
          icon={planningIcon}
        />
      </div>
    </section>
  );
};

export default Expertise;